import { getMessagesParser } from '@web/conversations/Message/MessageContent/messageContent.helpers';
import { useParsedContent } from '@web/common/hooks/useParsedContent';

export const useParsedMessageContent = (content: string, editedDateLabel?: string | null) => {
  const messageToHtmlParser = getMessagesParser(editedDateLabel);

  return useParsedContent(content, null, messageToHtmlParser);
};
